import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UsuarioAtivoService {

  constructor(private readonly http: HttpClient) { }

  public getRelatorioUsuarioAtivo(idEmpresa , spTransFlag , creditoFlag , idEndereco , idDepartamento , ordem , tipo) {

    return this.http.get (`/apiconnect/report/active-users/${idEmpresa}/companies?beneficioSPTransFlag=${spTransFlag}&bolsaCreditoFlag=
    ${creditoFlag}&idEndereco=${idEndereco}&idDepartamento=${idDepartamento}&ordem=${ordem}&tipo=${tipo}`, {
      observe: 'response',
      responseType: 'text',
    });
  }

  public getRelatorioUsuarioAtivoCsv(idEmpresa , spTransFlag , creditoFlag , idEndereco , idDepartamento , ordem , tipo){

    return this.http.get( `/apiconnect/report/active-users/${idEmpresa}/companies/csv?beneficioSPTransFlag=${spTransFlag}&bolsaCreditoFlag=
    ${creditoFlag}&idEndereco=${idEndereco}&idDepartamento=${idDepartamento}&ordem=${ordem}&tipo=${tipo}`, {
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }
}
